export const SET_LOADING = "SET_LOADING";
export const SET_ANALYSIS = "SET_ANALYSIS";
export const SET_ALL_ORDERS = "SET_ALL_ORDERS";
export const SET_RELEASED_ORDERS = "SET_RELEASED_ORDERS";
export const SET_RECEIVED_ORDERS = "SET_RECEIVED_ORDERS";
export const SET_CONFIRM_RELEASE_ORDERS = "SET_CONFIRM_RELEASE_ORDERS";
